import { toast } from 'react-toastify';
import css from './subscribe.module.scss';
import Modal from 'src/components/common/modal/modal';
import API from 'src/components/subscribe/api';
import { AxiosError } from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import { env } from 'src/constants/env';
import { useRef } from 'react';

interface UnsubscribeProps {
  email: string;
  onClose: () => void;
}

export default function UnsubscribeModal({ email, onClose }: Readonly<UnsubscribeProps>) {
  const captchaRef = useRef<ReCAPTCHA>(null);

  const unsubscribe = async (close: () => void) => {
    const token = await captchaRef.current?.executeAsync();
    if (email.length > 0 && token) {
      try {
        await API.unsubscribe({
          email,
          status: 0,
          captcha: token
        }).then(close);
      } catch (error) {
        toast(`${(error as AxiosError)?.response?.data}`);
      }
      close();
    }
  };

  return (
    <Modal isOpen={true} closeOnDocumentClick={false} onClose={onClose}>
      {(close: () => void) => (
        <div className={css.succesModal}>
          <button className={css.close} onClick={close}>
            &times;
          </button>
          <h3>Відмова від підписки</h3>
          <p>
            Ви дійно хочете скасувати підписку для <span>{email}</span>
          </p>
          <div className={css.btns}>
            <button className={css.actionBtn} onClick={close}>
              Залишити підписку
            </button>
            <button
              className={css.declineBtn}
              onClick={() => {
                unsubscribe(close);
              }}>
              Відмовитись від підписки
            </button>
          </div>
          <ReCAPTCHA
            ref={captchaRef}
            className={css.captcha}
            sitekey={env.REACT_APP_NZ_RECAPTCHA_SITE_KEY}
            hl='uk'
            size='invisible'
          />
        </div>
      )}
    </Modal>
  );
}
